var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2378_6622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.39167C25.8271 2.39167 32.6083 9.17292 32.6083 17.5C32.6083 25.8271 25.8271 32.6083 17.5 32.6083C9.17292 32.6083 2.39167 25.8271 2.39167 17.5C2.39167 9.17292 9.17292 2.39167 17.5 2.39167ZM17.5 0C7.83125 0 0 7.83125 0 17.5C0 27.1688 7.83125 35 17.5 35C27.1688 35 35 27.1688 35 17.5C35 7.83125 27.1688 0 17.5 0Z",
    fill: "#4B2B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0177 13.9271C21.6386 13.5625 21.0698 13.5917 20.7052 13.9417C20.3407 14.3209 20.3698 14.8896 20.7198 15.2542C21.3323 15.8521 21.6677 16.625 21.6677 17.4855C21.6677 18.3459 21.3323 19.1188 20.7198 19.7167C20.3407 20.0813 20.3407 20.6646 20.7052 21.0292C20.8802 21.2334 21.1427 21.3063 21.3761 21.3063C21.6094 21.3063 21.8282 21.2334 22.0323 21.0438C23.0094 20.1105 23.549 18.8417 23.549 17.4709C23.5344 16.1584 22.9948 14.8896 22.0177 13.9271Z",
    fill: "#4B2B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1489 11.2584C23.7697 10.9229 23.1718 10.9375 22.8364 11.3313C22.501 11.7104 22.5155 12.3084 22.9093 12.6438C24.2801 13.8834 25.0822 15.6479 25.0822 17.5C25.0822 19.3521 24.2801 21.1167 22.9093 22.3563C22.5301 22.6917 22.4864 23.2896 22.8364 23.6688C23.0114 23.8729 23.2739 23.9896 23.5364 23.9896C23.7551 23.9896 23.9739 23.9167 24.1489 23.7563C25.9135 22.1667 26.9343 19.9063 26.9343 17.5146C26.9489 15.1229 25.9426 12.8625 24.1489 11.2729V11.2584Z",
    fill: "#4B2B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 10.1063L11.9708 14.3063H8.61667C8.29583 14.3063 8.0625 14.5688 8.0625 14.8605V20.125C8.0625 20.4459 8.325 20.6792 8.61667 20.6792H11.9708L17.6 24.8938C17.9792 25.1709 18.4896 24.9084 18.4896 24.4417V10.5438C18.4896 10.0917 17.95 9.8292 17.6 10.1063Z",
    fill: "#4B2B5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2378_6622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMusicIcon);
export default __webpack_public_path__ + "static/media/audioMusicIcon.ad708930585049d848fd89df2a2b67b9.svg";
export { ForwardRef as ReactComponent };